import Element from '../../Element';
import Game from '../../../../Game';
import Renderable from '../../../../Component/Renderable';
import GameObject, { GameObjectEvent } from '../../../../GameObject/GameObject';
import UIImageComponent from '../../../../Component/UI/Image';
import LeaderboardHelper from '../../../../System/UI/LeaderboardHelper';
import UITextComponent from '../../../../Component/UI/Text';
import { applyDefaultButtonAnimation, removeBounceButtonAnimation } from '../../../../System/UI/UIHelper';
import { GameActions } from '../../../../State/Game/GameActions';
import { IFriendData } from '../../../../Player/PlayerProperty/Social/IPlayerSocialData';
import DateHelper from '../../../../Utility/DateHelper';
import {
    SEND_CURRENCY_TIMER_COOLDOWN,
    REQUEST_CURRENCY_TIMER_COOLDOWN,
    FRIEND_ALT_GIFT_TIMER_COOLDOWN,
} from '../../../../Constants/Timers';
import { PlayerActions } from '../../../../State/Player/PlayerActions';
import Interactable from '../../../../Component/Interactable';
import { isIOS } from '../../../../Utility/Platform';
import { track } from '../../../../Utility/Tracking/Track';
import { TSocialActionType } from '../../../../Utility/Tracking/DataSet/Transaction';
import { ContextType } from '../../../../State/Game/ContextType';
import { IScoreEntry } from '../../../../Utility/SDK/Drivers/IScoreEntry';
import { IGameState } from '../../../../State/Game/IGameState';
import { CustomPayloadPlacement } from 'Utility/EntryPoint/Payloads/ICustomPayload';

export interface IFriendItemData {
    playerId: number;
    offsets: [number, number, number, number];
}

const BASE_NAME: string = 'base';
const AVATAR_NAME: string = 'friend_avatar';
const BG_NAME: string = 'friend_bg';
const PLAYER_NAME: string = 'player_name';
const STAR_ICON_NAME: string = 'friend_star_icon';
const STAR_COUNT_NAME: string = 'friend_star_count';
const SEND_BTN_NAME: string = 'send_btn';
const REQUEST_BTN_NAME: string = 'request_btn';
const USER_TEXT: string = 'user_invite_text';
const IOS_TEXT: string = 'IOS_text';
const FRIENDS_ICON: string = 'invite_friends_icon';
const COIN_ICON: string = 'friend_coin';
const COIN_ICON_CONTAINER: string = 'friend_coin_container';
const TIMER_NAME: string = 'timer_txt';
const PLACEMENT_TEXT: string = 'placement_text';

const PLACEMENT_COLORS: string[] = ['#6d0a08', '#0d263e', '#470e0c', '#85270c'];
export default class FriendItem extends Element {
    private _active: boolean;
    private playerData: IScoreEntry;

    // Elements
    private userText: Element;
    private requestBtn: Element;
    private sendBtn: Element;
    private coinBtn: Element;
    private timerText: Element;
    private iosText: Element;
    private friendsIcon: Element;
    private base: Element;
    private coinIconContainer: Element;
    private friendsCover: Element;
    private avatar: Element;
    private placementText: Element;

    public create(params: IFriendItemData): void {
        super.create({
            name: `friend_item_${params.playerId}`,
            layout: {
                anchors: [0, 0, 0, 0],
                pivot: [0, 0],
                offsets: params.offsets,
            },
            children: [
                {
                    type: 'group',
                    name: BASE_NAME,
                    layout: {
                        anchors: [0, 0, 0, 0],
                        pivot: [0, 0],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'friend_part',
                            },
                        },
                    ],
                    children: [
                        {
                            type: 'group',
                            name: AVATAR_NAME,
                            layout: {
                                anchors: [0, 0, 0, 0],
                                pivot: [0, 0],
                                offsets: [-90, -26, -90, -26],
                                constrains: {
                                    widthMax: 52,
                                    widthMin: 52,
                                    heightMax: 52,
                                    heightMin: 52,
                                },
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'no_avatar',
                                    },
                                },
                            ],
                        },
                        {
                            type: 'group',
                            name: BG_NAME,
                            layout: {
                                anchors: [0, 0.5, 0, 0.5],
                                pivot: [0, 0.5],
                                offsets: [-13, 0, -13, 0],
                                scale: [0.71, 0.71],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'friends_cover_1',
                                    },
                                },
                            ],
                            children: [
                                {
                                    type: 'group',
                                    name: PLAYER_NAME,
                                    layout: {
                                        anchors: [0, 0.5, 0, 0.5],
                                        pivot: [0, 0.8],
                                        offsets: [-191, 5, -191, 5],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                text: 'Jane Doe',
                                                style: Game.style.getStyle('popup.friends_hub.friend_name'),
                                                align: 'left',
                                                bounds: [107, 45],
                                            },
                                        },
                                    ],
                                },
                                {
                                    type: 'group',
                                    name: 'placement_text',
                                    layout: {
                                        anchors: [0.5, 0.5, 0.5, 0.5],
                                        pivot: [0.5, 0.5],
                                        offsets: [130, 5, 130, 5],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                text: '1',
                                                style: Game.style.getStyle('popup.friends_hub.placement.1'),
                                                align: 'center',
                                                bounds: [130, 65],
                                            },
                                        },
                                    ],
                                },
                                {
                                    type: 'group',
                                    name: STAR_ICON_NAME,
                                    layout: {
                                        anchors: [0, 0.5, 0, 0.5],
                                        pivot: [0.4, 0],
                                        offsets: [-200, -1, -200, -1],
                                    },
                                    components: [
                                        {
                                            type: 'image',
                                            data: {
                                                cacheKey: 'shop_star_small',
                                            },
                                        },
                                    ],
                                    children: [
                                        {
                                            type: 'group',
                                            name: STAR_COUNT_NAME,
                                            layout: {
                                                anchors: [1, 0.5, 1, 0.5],
                                                pivot: [0, 0.5],
                                                offsets: [0, 2, 0, 2],
                                            },
                                            components: [
                                                {
                                                    type: 'text',
                                                    data: {
                                                        text: '999',
                                                        style: Game.style.getStyle('popup.friends_hub.star_count'),
                                                        align: 'left',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            type: 'group',
                            name: COIN_ICON_CONTAINER,
                            layout: {
                                anchors: [0.355, 0.5, 0.355, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: isIOS() ? [-90, 0, -90, 0] : [-88, 0, -88, 0],
                            },
                            children: [
                                {
                                    type: 'group',
                                    name: COIN_ICON,
                                    layout: {
                                        anchors: [0.355, 0.5, 0.355, 0.5],
                                        pivot: [0.5, 0.5],
                                        offsets: [-28, 0, -28, 0],
                                        scale: isIOS() ? [1.8, 1.8] : [1, 1],
                                    },
                                    components: [
                                        {
                                            type: 'image',
                                            data: {
                                                cacheKey: 'coin_medium',
                                            },
                                        },
                                        {
                                            type: 'input',
                                            data: {
                                                enabled: false,
                                                buttonMode: true,
                                            },
                                        },
                                    ],
                                },
                                {
                                    type: 'group',
                                    name: TIMER_NAME,
                                    layout: {
                                        anchors: [0.355, 0.5, 0.355, 0.5],
                                        pivot: [0.5, 0.5],
                                        offsets: [-28, -18, -28, -18],
                                        scale: [1, 1],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                text: '00:00',
                                                style: {
                                                    ...Game.style.getStyle('popup.friends_hub.timer'),
                                                },
                                                bounds: [54, 27],
                                                align: 'center',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },

                        {
                            type: 'group',
                            name: SEND_BTN_NAME,
                            layout: {
                                anchors: [0.6, 0.5, 0.6, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'button_green_friends',
                                    },
                                },
                                {
                                    type: 'input',
                                    data: {
                                        enabled: false,
                                        buttonMode: true,
                                    },
                                },
                            ],
                            children: [
                                {
                                    type: 'group',
                                    name: 'send_btn_txt',
                                    layout: {
                                        anchors: [0.5, 0.53, 0.5, 0.53],
                                        pivot: [0.5, 0.5],
                                        offsets: [0, 0, 0, 0],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                textLocalizationKey: 'Send',
                                                style: {
                                                    ...Game.style.getStyle('popup.green_btn'),
                                                    fontSize: 25,
                                                },
                                                bounds: [200, 80],
                                                align: 'center',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            type: 'group',
                            name: REQUEST_BTN_NAME,
                            layout: {
                                anchors: [0.855, 0.5, 0.855, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'button_blue_friend',
                                    },
                                },
                                {
                                    type: 'input',
                                    data: {
                                        enabled: false,
                                        buttonMode: true,
                                    },
                                },
                            ],
                            children: [
                                {
                                    type: 'group',
                                    name: 'request_btn_txt',
                                    layout: {
                                        anchors: [0.5, 0.46, 0.5, 0.46],
                                        pivot: [0.5, 0.5],
                                        offsets: [0, 0, 0, 0],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                textLocalizationKey: 'Request',
                                                style: {
                                                    ...Game.style.getStyle('popup.blue_btn'),
                                                    fontSize: 25,
                                                },
                                                bounds: [140, 80],
                                                align: 'center',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: USER_TEXT,
                            layout: {
                                anchors: [0.475, 0.5, 0.475, 0.5],
                                pivot: [0, 0.5],
                                offsets: [3, 0, 3, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'UserInvite',
                                        style: Game.style.getStyle('popup.friends_hub.user_invite'),
                                        align: 'center',
                                        bounds: [210, 170],
                                    },
                                },
                            ],
                        },
                        {
                            name: IOS_TEXT,
                            layout: {
                                anchors: [0.475, 0.5, 0.475, 0.5],
                                pivot: [0, 0.5],
                                offsets: [0, 0, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'Click&Collect',
                                        style: Game.style.getStyle('popup.friends_hub.user_invite'),
                                        align: 'center',
                                        bounds: [250, 120],
                                    },
                                },
                            ],
                        },
                        {
                            name: FRIENDS_ICON,
                            layout: {
                                anchors: [0.85, 0.5, 0.85, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [-20, 0, -20, 0],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'friends_icon_popup',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
            ...params,
        });

        this.userText = this.findChildByName(USER_TEXT) as Element;
        this.requestBtn = this.findChildByName(REQUEST_BTN_NAME) as Element;
        this.sendBtn = this.findChildByName(SEND_BTN_NAME) as Element;
        this.coinBtn = this.findChildByName(COIN_ICON) as Element;
        this.timerText = this.findChildByName(TIMER_NAME) as Element;
        this.iosText = this.findChildByName(IOS_TEXT) as Element;
        this.friendsIcon = this.findChildByName(FRIENDS_ICON) as Element;
        this.base = this.findChildByName(BASE_NAME) as Element;
        this.coinIconContainer = this.findChildByName(COIN_ICON_CONTAINER) as Element;
        this.friendsCover = this.findChildByName(BG_NAME) as Element;
        this.avatar = this.findChildByName(AVATAR_NAME) as Element;
        this.placementText = this.friendsCover.findChildByName(PLACEMENT_TEXT) as Element;

        if (isIOS()) {
        } else {
            applyDefaultButtonAnimation(this.sendBtn);
            this.sendBtn.on(GameObjectEvent.SELECTED, this.onSend.bind(this));

            applyDefaultButtonAnimation(this.requestBtn);
            this.requestBtn.on(GameObjectEvent.SELECTED, this.onRequest.bind(this));
        }
    }

    private onSend() {
        track('socialActionType', TSocialActionType.SEND_COINS);
        GameActions.setContext(ContextType.SEND_CURRENCY, {
            friendId: this.playerData.user.playerId,
        });
        this.updateTimers();
    }
    private onRequest() {
        GameActions.setContext(ContextType.REQUEST_CURRENCY, {
            friendId: this.playerData.user.playerId,
        });
        this.updateTimers();
    }
    private onGift() {
        if (!isIOS()) return;

        GameActions.setContext(ContextType.SEND_FRIEND_GIFT, {
            friendId: this.playerData.user.playerId,
            altGift: true,
            placement: CustomPayloadPlacement.SAGA_MAP,
        });
        this.updateTimers();
    }

    public updateTimers(state: IGameState = Game.store.getState()) {
        if (this.playerData === undefined || !this.requestBtn || !this.sendBtn) return;

        const friendsData: IFriendData[] = state.playerState.social.friendData;
        const currentFriendData: IFriendData = friendsData.find(
            (friendData: IFriendData) => friendData.playerId === this.playerData.user.playerId
        );

        if (currentFriendData) {
            if (isIOS()) {
                this.updateCoinTimer(currentFriendData.altGiftCooldown);
            } else {
                this.updateButton(
                    this.sendBtn,
                    currentFriendData.currencySendTimer,
                    SEND_CURRENCY_TIMER_COOLDOWN,
                    Game.locale.getText('Send'),
                    'button_green_friends',
                    'popup.green_btn'
                );

                this.updateButton(
                    this.requestBtn,
                    currentFriendData.currencyRequestTimer,
                    REQUEST_CURRENCY_TIMER_COOLDOWN,
                    Game.locale.getText('Request'),
                    'button_blue_friend',
                    'popup.blue_btn'
                );
            }
        } else {
            if (isIOS()) {
                this.updateCoinTimer(null);
            } else {
                this.setButtonEnabled(
                    this.requestBtn,
                    Game.locale.getText('Request'),
                    'button_blue_friend',
                    'popup.blue_btn'
                );
                this.setButtonEnabled(
                    this.sendBtn,
                    Game.locale.getText('Send'),
                    'button_green_friends',
                    'popup.green_btn'
                );
            }
        }
    }
    private updateButton(
        button: GameObject,
        timer: number,
        cooldown: number,
        text: string,
        texture: string,
        style: string
    ): void {
        if (timer !== null) {
            const timerDate: Date = DateHelper.getDate(timer);
            if (DateHelper.isCompleted(timerDate, cooldown)) {
                PlayerActions.updateTimers();

                this.setButtonEnabled(button, text, texture, style);
            } else {
                this.setButtonDisabled(button, timerDate.getTime() + cooldown);
            }
        } else {
            this.setButtonEnabled(button, text, texture, style);
        }
    }
    private setButtonEnabled(button: GameObject, text: string, texture: string, style: string): void {
        if (!button) return;

        if (button.hasComponent(Interactable)) {
            const interactable: Interactable = button.getComponent(Interactable);
            interactable.enabled = true;
            interactable.buttonMode = true;
            button.getComponentsInChildren(UIImageComponent)[0].texture = texture;
            button.getComponentsInChildren(UITextComponent)[0].style = {
                ...Game.style.getStyle(style),
                fontSize: 25,
            };
        }
        button.getComponentsInChildren(UITextComponent)[0].text = text;
    }
    private setButtonDisabled(button: GameObject, time: number): void {
        if (!button) return;

        if (button.hasComponent(Interactable)) {
            const interactable: Interactable = button.getComponent(Interactable);
            interactable.enabled = false;
            interactable.buttonMode = false;
        }
        button.getComponentsInChildren(UIImageComponent)[0].texture = 'button_grey_friends';
        button.getComponentsInChildren(UITextComponent)[0].style = {
            ...button.getComponentsInChildren(UITextComponent)[0].style,
            fontSize: 25,
            stroke: '#303f5a',
        };
        button.getComponentsInChildren(UITextComponent)[0].text = DateHelper.timeTo(
            DateHelper.now,
            DateHelper.getDate(time),
            'hh:mm:ss'
        );
    }
    private updateCoinTimer(time: number): void {
        if (this.playerData.user.isCurrentUser) return;

        const coinImage: UIImageComponent = this.coinBtn.getComponent(UIImageComponent);
        const coinInteractable: Interactable = this.coinBtn.getComponent(Interactable);
        const timerText: UITextComponent = this.timerText.getComponent(UITextComponent);

        if (time != null) {
            const cooldown: Date = DateHelper.getDate(time);

            // Show timer
            coinImage.texture = 'friends_coin2';
            timerText.text = DateHelper.timeTo(
                DateHelper.now,
                DateHelper.getDate(cooldown.getTime() + FRIEND_ALT_GIFT_TIMER_COOLDOWN),
                'hh:mm:ss'
            );

            coinInteractable.enabled = false;
            coinInteractable.buttonMode = false;
        } else {
            // Hide timer
            coinImage.texture = 'friends_coin';
            timerText.text = '';

            coinInteractable.enabled = true;
            coinInteractable.buttonMode = true;
        }
    }

    public setPlayerData(data: IScoreEntry) {
        this.active = !!data;
        this.playerData = data;

        if (!data) return;

        this.name = `friend_item_${data.user.playerId}`;

        // Hide send button if the current user or if on ios
        this.sendBtn.getComponent<Renderable>(Renderable).visible = !data.user.isCurrentUser && !isIOS();

        // Hide request button if current user or if on ios
        this.requestBtn.getComponent<Renderable>(Renderable).visible = !data.user.isCurrentUser && !isIOS();

        // Hide user invite text if not current user
        this.userText.getComponent<Renderable>(Renderable).visible = data.user.isCurrentUser;

        // Hide ios text if current user and not on ios
        this.iosText.getComponent<Renderable>(Renderable).visible = !data.user.isCurrentUser && isIOS();

        // Hide invite icon if not current user
        this.friendsIcon.getComponent<Renderable>(Renderable).visible = data.user.isCurrentUser;

        // Set background if friend or current user
        this.base.getComponent(UIImageComponent).texture = data.user.isCurrentUser ? 'user_part' : 'friend_part';

        // Set medal placement icon
        const placement: number = Math.min(data.rank, 4);
        this.friendsCover.getComponent(UIImageComponent).texture = `friends_cover_${placement}`;
        const placementTextRank = this.placementText.getComponent(UITextComponent);
        placementTextRank.text = String(data.rank);
        placementTextRank.style = Game.style.getStyle(`popup.friends_hub.placement.${placement}`);

        // Set player avatar
        const avatar: GameObject = this.avatar;
        const avatarKey = LeaderboardHelper.getPlayerAvatarId(data.user.id, data.user.isCurrentUser);
        LeaderboardHelper.setPlayerAvatar(avatarKey, data.user.avatarUrl, avatar.getComponent(UIImageComponent));

        const playerNameText: UITextComponent = this.findChildByName(PLAYER_NAME).getComponent(UITextComponent);
        playerNameText.style.fill = PLACEMENT_COLORS[placement - 1];
        playerNameText.style.stroke = PLACEMENT_COLORS[placement - 1];
        // Set player name
        playerNameText.text = data.user.handle;

        // Set player star count
        const starCount: UITextComponent = this.findChildByName(STAR_COUNT_NAME).getComponent(UITextComponent);
        starCount.text = data.score.toString();
        starCount.style = {
            ...starCount.style,
            stroke: PLACEMENT_COLORS[placement - 1],
            fontSize: 28,
        };
        this.coinBtnSetup(data);
        this.updateTimers();
    }

    public get active(): boolean {
        return this._active;
    }
    public set active(value: boolean) {
        if (this.active === value) return;

        this._active = value;

        const renderable: Renderable = this.getComponent<Renderable>(Renderable);
        renderable.alpha = Number(value);

        this.updateTimers();
    }

    private coinBtnSetup(data: IScoreEntry): void {
        const coinBtn: Element = this.coinBtn as Element;
        const coinBtnContainer: Element = this.coinIconContainer as Element;
        const coinInteractable: Interactable = this.coinBtn.getComponent(Interactable);
        const friendData: IFriendData = Game.store
            .getState()
            .playerState.social.friendData.find((friend: IFriendData) => friend.playerId === data.user.playerId);

        if (!isIOS() || data.user.isCurrentUser) {
            removeBounceButtonAnimation(this.coinBtn);
            coinBtnContainer.getChildByName(TIMER_NAME).getComponent<Renderable>(Renderable).visible = false;
            coinBtn.off(GameObjectEvent.SELECTED, this.onGift.bind(this));
        } else {
            applyDefaultButtonAnimation(this.coinBtn);
            coinBtn.on(GameObjectEvent.SELECTED, this.onGift.bind(this));
        }

        //Hide the plus icon and timer if not ios or if current user
        coinBtn
            .getComponentsInChildren(Renderable)
            .slice(1)
            .forEach((renderable: Renderable) => (renderable.visible = isIOS() && !data.user.isCurrentUser));

        // Disable the icon if not ios or if current user
        coinInteractable.enabled = isIOS() && !data.user.isCurrentUser;
        coinInteractable.buttonMode = isIOS() && !data.user.isCurrentUser;

        // Set coin texture
        coinBtn.getComponent(UIImageComponent).texture =
            (isIOS() && friendData && friendData.altGiftCooldown != null) || data.user.isCurrentUser
                ? 'friends_coin2'
                : 'coin_medium_popup';
        coinBtnContainer.getComponent<Renderable>(Renderable).visible = !data.user.isCurrentUser;
    }
}
